export enum GroupWriteBack {
    Disabled = "Disabled",
    Enabled = "Enabled",
}
